import * as J from "../../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
import { getAspectCorrectedCoordinates as Z } from "../../utilities/uv.js";
import { grain as $ } from "../../helpers/grain.js";
import { distort as oo } from "../../helpers/distort.js";
import { glow as to } from "../../helpers/glow.js";
import { edgeMask as so } from "../../helpers/edgeMask.js";
const ao = {
  name: "Chromatic6",
  collection: "chromatic",
  tags: ["wave", "gradient"],
  props: {
    speed: {
      type: Number,
      default: 1,
      description: "The speed of the wave effect."
    }
  },
  fragmentNode: (m) => {
    const {
      vec3: E,
      vec4: O,
      time: T,
      mix: n,
      sin: d,
      float: o,
      pow: c,
      uv: l,
      color: t
    } = J, f = t("#525a5c"), N = t("#3d4147"), u = t("#2c3037"), C = t("#7e7e7e"), S = t("#2a3337"), p = t("#2d2f37"), I = 0.7, R = 0.5, D = 0, G = 0, A = 0.3, L = 0.2, g = 44, Y = 1, F = 0.015, b = 1.5, v = 0.4, w = 0.02, x = 0.3, U = 10, B = 0.8, V = 0.2, s = l(), { correctedUV: W } = Z(), r = oo(s, A, L, g), h = c(f, o(2.2)), y = c(N, o(2.2)), k = c(u, o(2.2)), H = c(C, o(2.2)), P = n(
      h,
      y,
      s.y
    ), K = n(
      H,
      k,
      s.x
    ), _ = n(
      P,
      K,
      s.x
    ), a = r.x.sub(0.3), i = r.y.sub(0.5), M = i.mul(a).add(i.mul(a)).negate(), e = o(1).add(
      o(Y).mul(
        d(
          M.add(T.mul(m.speed.uniform).mul(0.02)).div(F)
        )
      )
    ), Q = so({
      inset: I,
      softness: R,
      offsetX: D,
      offsetY: G
    }), X = E(e, e, e).mul(Q).mul(b), z = n(
      p.mul(V),
      S.mul(B),
      s.y.mul(s.x)
    ), j = $(v)(W), q = O(
      z.add(_.mul(X)).sub(j),
      1
    );
    return to(q, _, w, x, U);
  }
};
export {
  ao as componentDefinition,
  ao as default
};
